<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import * as echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal.length) {
          this.loadEcharts(newVal);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let xAxisData = val.map((item) => item.date);
        let seriesData = val.map((item) => item.num);
        let option = {
          // color: ["#518eff", "#18d3c6"],
          grid: {
            left: "3%",
            right: "3%",
            top: "10%",
            bottom: "5%",
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            // color: ["#16d0c8", "#ffc000"],
            show: true,
            // icon: "circle",
            right: "3%",
            top: "0",
          },
          yAxis: [
            {
              type: "value",
              // position: "left",
              nameTextStyle: {
                color: "#00FFFF",
              },
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "rgba(135,140,147,0.8)",
                  // color: "#f1f3f8",
                },
              },
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                formatter: "{value}",
                color: "#666",
                fontSize: 14,
              },
            },
          ],
          xAxis: [
            {
              type: "category",
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#f1f3f8",
                },
              },
              axisLabel: {
                inside: false,
                // textStyle: {
                color: "#666", // x轴颜色
                fontWeight: "normal",
                fontSize: "14",
                lineHeight: 22,
                // },
              },
              data: xAxisData,
              // data: [502.84, 205.97, 332.79, 281.55, 398.35, 214.02],
            },
          ],
          series: [
            {
              name: "人数",
              type: "bar",
              //   barGap: 0,
              itemStyle: {
                color: "#5984F1",
                // borderRadius: [6, 6, 6, 6],
              },
              label: {
                show: true,
                position: "top",
                fontSize: 16,
              },
              barWidth: "20%",
              yAxisIndex: 0,
              data: seriesData,
            },
            // {
            //   name: "总人数",
            //   type: "line",
            //   showAllSymbol: true,
            //   symbol: "circle",
            //   symbolSize: 15,
            //   lineStyle: {
            //     color: "#00b3f4",
            //     shadowColor: "rgba(0, 0, 0, .3)",
            //     shadowBlur: 0,
            //   },
            //   label: {
            //     show: true,
            //     fontSize: 16,
            //     color: "#00b3f4",
            //   },
            //   itemStyle: {
            //     color: "#00b3f4",
            //     borderColor: "#fff",
            //     borderWidth: 3,
            //     shadowColor: "rgba(0, 0, 0, .3)",
            //     shadowBlur: 0,
            //     shadowOffsetY: 2,
            //     shadowOffsetX: 2,
            //   },
            //   tooltip: {
            //     show: false,
            //   },
            //   data: seriesData,
            // },
          ],
        };
        if (this.dom != null && this.dom != "" && this.dom != undefined) {
          this.dom.dispose();
        }
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },

  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
